import Filter from "../Filter/Filter";
import React from "react";
import SearchPanel from "../SearchPanel";
import '../Filter/Filter.scss';
import VendorForm from "../VendorForm/VendorForm";

export default class TeamMemberListFilter extends Filter {
    constructor(props) {
        super(props);
    }

    handleDropdownChange(query, optionType, value, valueKey, ...rest) {
        if (valueKey === 'VENDOR_TYPE') {
            delete query.VENDOR_SUBTYPE;
        }

        super.handleDropdownChange(query, optionType, value, valueKey, ...rest);
    }

    render() {
        const {query, paneIndex} = this.state;

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {openFilter: () => this.openFilter()})}
                </div>
                <SearchPanel ref='searchPanel'>
                    <nav className='Filter_nav'>
                        <div className='Filter_button' onClick={this.close}>Close</div>
                    </nav>
                    <VendorForm theme='dark'
                                data={query}
                                paneIndex={paneIndex}
                                isFilter={true}
                                handleSubmit={this.handleSubmit}
                                handleCancel={this.clear}
                                handleParentChange={this.handleChange}
                                handleParentDropdownChange={this.handleDropdownChange}
                                handlePaneChange={(key) => this.setState({paneIndex: key})}
                    />
                </SearchPanel>
            </div>
        );
    }
}